import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { IApplicationState } from '../../store/applicationState';
import { IGroupMember as IMember } from '../../store/group/groupState';

import Contact from '../../components/shared/contact/Contact';
import MemberImage from '../../components/shared/memberimage/MemberImage';
import Modal from '../../components/shared/modal/Modal';
import Icon from '../../components/shared/icon/Icon'

import getConfiguration from '../../services/environment';
import { setEmailWhitelisted } from '../../services/maintenance';

interface IStateProps {
    viewerIsDi: boolean;
    browsingSelf: boolean;
    currentGroup: string | undefined;
}

interface IState {
    showMemberModal: boolean;
    bounceStatus: string;
    bounceActive: boolean;
}

interface IOwnProps {
    member: IMember;
}

type Props = IOwnProps & IStateProps;

let selfServiceAuthority = 'https://dit.di.dk/';

class Member extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            showMemberModal: false,
            bounceStatus: props.member.bounce.status,
            bounceActive: props.member.bounce.active
        }
    }

    public async componentDidMount() {
        selfServiceAuthority = (await getConfiguration()).selfServiceAuthority;
    }

    public render() {
        return <React.Fragment>
            <span className="contact contact--link contact--minor pointer" onClick={this.toggleMemberModal}>
                <MemberImage member={this.props.member} />
                <div className="contact__body">
                    <h2 className="contact__headline">{this.props.member.fullName}</h2>
                    {this.props.member.businessCard ?
                        <h3 className="contact__sub-headline">
                            {this.props.member.businessCard.title}
                            {this.props.member.businessCard.title && this.props.member.businessCard.companyName ? <>,<br /></> : null}
                            {this.props.member.businessCard.companyName}
                        </h3>
                        : null}
                    <span className="contact__more">Læs mere</span>

                    {this.props.viewerIsDi && (this.props.member.bounce && (this.state.bounceActive && this.state.bounceStatus !== 'whitelisted')) &&
                        <div className="notification notification--warning">
                            <Icon name="meninger" />
                            <span>Mail kan ikke leveres.</span>
                        </div>
                    }

                    {this.props.viewerIsDi && (!this.props.member.businessCard || !this.props.member.businessCard.email) &&
                        <div className="notification notification--warning">
                            <Icon name="meninger" />
                            Data mangler.
                        </div>
                    }
                </div>
            </span>

            <Modal show={this.state.showMemberModal} onClose={this.toggleMemberModal}>
                <Contact member={this.props.member} modifierClass="contact--medium" />

                {(!this.props.member.descriptionGroups || this.props.member.descriptionGroups.find(x => x === this.props.currentGroup) !== undefined) && this.props.member.description ?
                    <div className="rich-text">
                        <h3>Beskrivelse</h3>
                        <p>{this.props.member.description.split('\n').map((item, key) => <React.Fragment key={key}>{item}{'\n'}<br /></React.Fragment>)}</p>
                    </div>
                    : null}
                {this.props.viewerIsDi && (!this.props.member.businessCard || !this.props.member.businessCard.email) &&
                    <React.Fragment>
                        {this.props.member.description && <br />}
                        <div className="notification notification--warning">
                            <Icon name="meninger" />
                            Der blev ikke fundet en aktiv ansættelse for {this.props.member.fullName} (DInr: {this.props.member.diNumber}) på personens tilknyttede virksomhed til gruppen (DInr: {this.props.member.businessCard ? this.props.member.businessCard.companyId : 'ukendt'}). Kontroller om person er fratrådt, eller er registreret med forkert virksomhed i gruppen.
                        </div>
                    </React.Fragment>
                }

                {(this.props.viewerIsDi || this.props.browsingSelf) &&
                    <React.Fragment>
                        {(this.props.member.description || !this.props.member.businessCard || !this.props.member.businessCard.email) && <br />}
                        <Link to={`/Profile/${this.props.member.diNumber}`} className="button button--action has-icon pointer">
                            <span className="text">
                                <span className="icon icon--right-spacing">
                                    <Icon name="edit" />
                                </span>
                                Rediger profil
                            </span>
                        </Link>
                        {this.props.viewerIsDi &&
                            <React.Fragment>
                                <br />
                                <a href={`${selfServiceAuthority}/Person/${this.props.member.diNumber}`} className="button button--action has-icon pointer" target="_blank" rel="nofollow noopener noreferrer">
                                    <span className="text">
                                        <span className="icon icon--right-spacing">
                                            <Icon name="house" />
                                        </span>
                                        Min side personprofil
                                </span>
                                </a>
                            </React.Fragment>
                        }
                    </React.Fragment>
                }
                {this.props.viewerIsDi && (this.props.member.bounce && (this.state.bounceActive && this.state.bounceStatus !== 'whitelisted')) &&
                    <>
                    <br />
                    <br />
                    <p className="notification notification--warning">
                        <Icon name="meninger" />
                        Mail til {this.props.member.bounce.email} kunne ikke leveres {this.props.member.bounce.timestamp}. Forsøgt leveret {this.props.member.bounce.count} gange.<br />
                    </p>
                    <div>
                        <br />
                        {(this.props.member.bounce.type === 'hard') &&
                        <p>
                            Dette kan skyldes at personen er fratrådt. Kontakt personen eller virksomheden for at kontrollere om e-mail adresse er ok. Du kan enten godkende nuværende e-mail adresse eller ændre e-mail adresse for at gøre det muligt fortsat at sende til personen.<br />
                            <br />
                            Hvis du ikke godkender e-mail adresse eller ændrer e-mail adresse/ansættelse indenfor de næste 7 dage vil personen blive fjernet fra gruppen og fjernet fra virksomheden.
                        </p>}

                        {(this.props.member.bounce.type === 'soft') &&
                        <p>
                            Dette kan være midlertidigt teknisk problem. Hvis problemet fortsætter vil personen automatisk blive fjernet fra gruppen.
                        </p>}
                        <p>Klik på knappen nedenfor for at whiteliste e-mailadressen og løse fejlen.</p><br />
                        <button className="button button--primary button--small" onClick={this.whitelist}><span className="text"><span className="icon icon--right-spacing"><Icon name="checkmark" /></span>Whitelist</span></button>
                    </div>
                    </>
                }
            </Modal>
        </React.Fragment>;
    }

    private toggleMemberModal = () => this.setState(prevState => ({ showMemberModal: !prevState.showMemberModal }));

    private whitelist = async (e: React.FormEvent<HTMLButtonElement>) => {
        e.preventDefault();
        const email = this.props.member.bounce.email;
        const diNumber = this.props.member.diNumber;

        await setEmailWhitelisted(diNumber, email);

        this.setState({
            bounceStatus: 'whitelisted'
        });
    };
}

const mapStateToProps = (state: IApplicationState, props: IOwnProps): IStateProps => {
    const browsingSelf = (state.oidc.user && state.oidc.user.profile && state.oidc.user.profile.Id.toString() === props.member.diNumber.toString()) || false;
    const viewerIsDi = state.oidc.user && state.oidc.user.profile && state.oidc.user.profile.role === 'DI';
    const currentGroup = state.groupData.currentGroup;

    return { viewerIsDi, browsingSelf, currentGroup };
}

const container = connect(mapStateToProps)(Member);

export default container;